const t = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Yesterday Icon</title><desc>A picture depicting a calendar with a back arrow in the middle.</desc><path d="M10.68 15.38h6.13v-1.75h-6.13V11l-3.49 3.5 3.49 3.5v-2.62z"/><path d="M19 4h-1V2h-2v2H8V2H6v2H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2zm0 16H5V9h14z"/></svg>';
export {
  t as default
};
